<form class="form-popup" [formGroup]="formGroup">
    <mat-form-field appearance="fill">
        <mat-label>User Name</mat-label>
        <input
            matInput
            name="User Name"
            autocomplete="off"
            formControlName="userName"
            />
        <mat-error *ngFor="let validation of userValidationMessages.userName">
            <mat-error *ngIf="formGroup.controls.userName.hasError(validation.type)">
                {{validation.message}}
            </mat-error>
        </mat-error>
    </mat-form-field>
    <aims-lookup
        name="Employee Record"
        [gridText]="'Select an Employee'"
        [values]="employees"
        [displayPropertyName]="'fullName'"
        [idPropertyName]="'employeeId'"
        [columnsInGrid]="employeeColumns"
        (valueChange)="employeeLookupChange($event)"
        [required]="isEmployeeLookupRequired"
        [altDisplay]="(formGroup.controls.employeeId.value | getText:'employeeId':'fullName':employees) || 'Select an Employee'"
        >
    </aims-lookup>

    <mat-form-field appearance="fill" *ngIf="isAimsAdmin">
        <mat-label>Select Company</mat-label>
        <mat-select
            formControlName="tenantId"
            class="fullWidth"
            name="Tenant"
            >
            <mat-option *ngFor="let t of tenants | async" [value]="t.tenantId">
                {{ t.tenantName }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Business Email (Used for password reset)</mat-label>
        <input
            matInput
            type="email" email
            name="Business Email (Used for password reset)"
            autocomplete="off"
            formControlName="email"
            required
        />
    </mat-form-field>

    <mat-checkbox formControlName="setPwd" (change)="handleSetPwdCheckboxChange($event)" >
        Manually Set Password
    </mat-checkbox>

    <mat-checkbox formControlName="generatePwd" (change)="handleGeneratePwdCheckboxChange($event)" >
        Auto-Generate Temporary Password
    </mat-checkbox>

    <div *ngIf="!formGroup.controls.generatePwd.value">
    <mat-form-field appearance="fill" >
        <mat-label>Password (User will be required to reset)</mat-label>
        <input
            matInput
            [type]="hidePassword ? 'password' : 'text'"
            name="Temporary Password"
            formControlName="password"
            required
            />
        <button id="hidePasswordBtn" mat-icon-button matSuffix (click)="hidePassword = !hidePassword"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword" tabindex="-1">
            <mat-icon>{{hidePassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngFor="let validation of userValidationMessages.password">
            <mat-error *ngIf="formGroup.controls.password.hasError(validation.type)">
                {{validation.message}}
            </mat-error>
        </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Confirm Password</mat-label>
        <input
            matInput
            [type]="hideConfirmPassword ? 'password' : 'text'"
            name="Confirm Password"
            formControlName="confirmPassword"
            required
                />
        <button id="hideConfirmPasswordBtn" mat-icon-button matSuffix
            (click)="hideConfirmPassword = !hideConfirmPassword"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hideConfirmPassword" tabindex="-1">
            <mat-icon>{{hideConfirmPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error *ngFor="let validation of userValidationMessages.confirmPassword">
            <mat-error *ngIf="formGroup.controls.confirmPassword.hasError(validation.type)">
                {{validation.message}}
            </mat-error>
        </mat-error>
    </mat-form-field>
    </div>

</form>
